/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersassignnomatch3Inputs */

const en_partnersassignnomatch3 = /** @type {(inputs: Partnersassignnomatch3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No business found`)
};

const de_partnersassignnomatch3 = /** @type {(inputs: Partnersassignnomatch3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Betrieb gefunden`)
};

/**
* | output |
* | --- |
* | "No business found" |
*
* @param {Partnersassignnomatch3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersassignnomatch3 = /** @type {((inputs?: Partnersassignnomatch3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersassignnomatch3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersassignnomatch3(inputs)
	return de_partnersassignnomatch3(inputs)
});
export { partnersassignnomatch3 as "partnersAssignNoMatch" }